/** @format */

import {ReactNode} from 'react';

import IconFunnel from '../assets/IconFunnel';
import IconKPI from '../assets/IconKPI';
import IconProperty from '../assets/IconProperty';
import IconSensors from '../assets/IconSensors';
import IconStubs from '../assets/IconStubs';
import {WidgetBlockId} from '../models/widgets';

const getWidgetIcon = (blockId: WidgetBlockId, fill?: string): ReactNode => {
  switch (blockId) {
    case 'properties':
      return <IconProperty fill={fill} />;
    case 'kpi':
      return <IconKPI fill={fill} />;
    case 'sensors':
      return <IconSensors fill={fill} />;
    case 'funnel':
      return <IconFunnel fill={fill} />;
    case 'stubs':
      return <IconStubs fill={fill} />;
    default:
      return null;
  }
};

export default getWidgetIcon;
